import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../../components/Button';
import { SuccessIcon } from '../../components/icons';

const pageWrap = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  paddingBottom: 40,
  flexDirection: 'column',
  letterSpacing: 0.5,
  marginTop:50
};

const iconWrap = {
  width: 224,
  height: 224,
  borderRadius: '50%',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: '#f5f5f5',
  marginBottom: 32,
};

const messageStyle = {
  margin: '16px 0 40px',
  textAlign: 'center',
  lineHeight: '1.5',
  fontSize: 16,
};

export default function SuccessPage(props) {
  const {
    match: { params },
  } = props;
  return (
    <div style={pageWrap}>
      <div style={iconWrap}>
        <SuccessIcon />
      </div>
      <div style={{ fontSize: 24, fontWeight: 600 }}>Success</div>
      <div style={messageStyle}>
        HDS{' '}
        <Link to={`/order/${params.orderId}`}>
          #{params.orderId}
        </Link>{' '}
        was added.
      </div>
      <Link to="/home">
        <Button buttonType="ButtonPrimaryMedium" buttonText="Done"/>
      </Link>
      <div style={{marginTop:16}}>
      <Link to="/new-order">
        <Button buttonType="ButtonTertiaryMedium" buttonText="New Order"/>
      </Link>
      </div>
    </div>
  );
}
